export default "__VITE_ASSET__7842c117__"